import { useDataCatalog } from "@/composable/data-catalog";
import { AggregateType, DustDataType } from "@soft-db/data-formatter";
import { FieldFactory } from "@soft-db/form";
import { SoftSelect } from "@soft-db/ui";
import { PropType } from "vue";
import * as z from "zod";
import { QueryDataConfigForm } from "./QueryDataConfig";

export default defineComponent({
	name: "DustDataConfigSettings",

	props: {
		useField: {
			type: Function as PropType<FieldFactory<QueryDataConfigForm>>,
			required: true,
		},
	},

	setup(props) {
		const { t } = useI18n();
		const dataField = props.useField("$dataConfig.data", { schema: z.nativeEnum(DustDataType) });
		const aggregateField = props.useField("$dataConfig.aggregate", {
			schema: z.nativeEnum(AggregateType),
		});
		const particleSizeField = props.useField("$dataConfig.particleSize", {
			schema: z.number().min(0),
		});

		onMounted(() => {
			if (particleSizeField.data.value === null || particleSizeField.data.value === undefined) {
				particleSizeField.data.value = 0;
			}
		});

		// For now, we force dust to always be of concentration type
		watch(
			() => dataField.data.value,
			(value) => {
				if (!value || value !== DustDataType.CONCENTRATION) {
					dataField.data.value = DustDataType.CONCENTRATION;
				}
			},
			{ immediate: true }
		);

		const particleSizeItems = computed(() => [
			{
				value: 0,
				name: t("common.all"),
			},
			{
				value: 1,
				name: "1μm",
			},
			{
				value: 2.5,
				name: "2.5μm",
			},
			{
				value: 4,
				name: "4μm",
			},
			{
				value: 10,
				name: "10μm",
			},
		]);

		const { generateMenuEntries, WeatherAggregates } = useDataCatalog();

		const aggregates = generateMenuEntries(WeatherAggregates);

		return () => (
			<>
				<SoftSelect
					{...aggregateField.attrs}
					label={t("dashboard.aggregate")}
					items={aggregates}
					itemText="name"
					itemValue="value"
					required
				/>
				<SoftSelect
					{...particleSizeField.attrs}
					label={t("dashboard.particleSize")}
					items={particleSizeItems.value}
					itemText="name"
					itemValue="value"
				/>
			</>
		);
	},
});
